var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "donation-credit-calculator__wrapper",
      class: _vm.language === "fr" ? "french-input" : "",
    },
    [
      _c(
        "label",
        {
          staticClass: "donation-credit-calculator__labels",
          attrs: { for: "donation-credit-calculator__province-select" },
        },
        [_vm._v("\n    " + _vm._s(_vm.translation("provinceLabel")) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.province,
              expression: "province",
            },
          ],
          staticClass: "donation-credit-calculator__inputs",
          class: !_vm.province ? "disabled" : "",
          attrs: { id: "donation-credit-calculator__province-select" },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.province = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        [
          _c("option", { attrs: { disabled: "", value: "" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.translation("selectProvincePlaceholder")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.provinces, function (info, key) {
            return _c("option", { key: key, domProps: { value: key } }, [
              _vm._v("\n      " + _vm._s(info.label[_vm.language]) + "\n    "),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.frequencylist
        ? _c(
            "label",
            {
              staticClass: "donation-credit-calculator__labels",
              attrs: { for: "donation-credit-calculator__frequency-select" },
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.translation("frequencyLabel")) + "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.frequencylist
        ? _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.frequencySelector,
                  expression: "frequencySelector",
                },
              ],
              staticClass: "donation-credit-calculator__inputs",
              attrs: { id: "donation-credit-calculator__frequency-select" },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.frequencySelector = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            _vm._l(_vm.parsedFrequencyArray, function (key) {
              return _vm.frequencyObject[key]
                ? _c("option", { key: key, domProps: { value: key } }, [
                    _vm._v(
                      "\n      " + _vm._s(_vm.getFrequencyLabel(key)) + "\n    "
                    ),
                  ])
                : _vm._e()
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "donation-credit-calculator__labels",
          attrs: { for: "donation-credit-calculator__donation-input" },
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.translation("donationAmountLabel")) + "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.donationInput,
            expression: "donationInput",
          },
        ],
        staticClass: "donation-credit-calculator__inputs",
        attrs: {
          id: "donation-credit-calculator__donation-input",
          type: "text",
          inputmode: "decimal",
          maxlength: "7",
          min: "0",
          autocomplete: "off",
          pattern: "\\d+(\\.\\d{1,2})?",
          placeholder: _vm.translation("donationPlaceholder"),
        },
        domProps: { value: _vm.donationInput },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.donationInput = $event.target.value
            },
            _vm.handleInput,
          ],
          keypress: _vm.preventNonNumeric,
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn",
          class:
            !_vm.isProvinceSelected ||
            !_vm.donationInput ||
            _vm.donationInput <= 0
              ? "btn--black btn--disabled"
              : "btn--yellow",
          attrs: {
            disabled:
              !_vm.isProvinceSelected ||
              !_vm.donationInput ||
              _vm.donationInput <= 0,
          },
          on: { click: _vm.calculateCredits },
        },
        [
          _c("span", { staticClass: "btn__content" }, [
            _c("span", { staticClass: "btn__text" }, [
              _vm._v(_vm._s(_vm.translation("calculateButton"))),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "donation-credit-calculator__results" }, [
        _c(
          "p",
          { staticClass: "title" },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.translation("resultsTitle")) + "\n      "
            ),
            _c("toggle-tip", {
              attrs: {
                open: _vm.openTooltipIcon,
                close: _vm.close,
                description: _vm.translation("donationToolTip"),
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "results__row" }, [
          _c("p", [_vm._v(_vm._s(_vm.translation("totalDonatedLabel")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.formatCurrency(_vm.totalDonated)))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "results__row" }, [
          _c("p", [_vm._v(_vm._s(_vm.translation("federalCreditLabel")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.formatCurrency(_vm.federalCredit)))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "results__row" }, [
          _c("p", [_vm._v(_vm._s(_vm.translation("provincialCreditLabel")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.formatCurrency(_vm.provincialCredit)))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "results__row" }, [
          _c("p", { staticClass: "total" }, [
            _vm._v(_vm._s(_vm.translation("totalCreditLabel"))),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "total" }, [
            _vm._v(_vm._s(_vm.formatCurrency(_vm.totalCredit))),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-currency" }, [
      _c("div", [_vm._v("$")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }